import { useState, useCallback, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import { actiontype } from '../utils/constants';
import { fetchBNBBalance } from '../utils/wallet';
import { StatusAPI } from './types';
import { toast } from 'react-toastify';
import { ErrorHelper } from '../utils/helpers';
import { useWallet } from '../../context/WalletContext';
import { WalletOption, BlockChainEnum } from '../../context/AppContext/types';
import mixpanel from 'mixpanel-browser';
import {
  DAILY_ACTIVE_USERS,
  DAILY_ACTIVE_WALLETS,
} from '../utils/constants/mixpanel';

export const useConnectWallet = () => {
  const {
    state: {
      wallet: { account, afkelephants },
    },
    dispatch,
  } = useApp();
  const {
    state: { walletManager },
  } = useWallet();

  // const handleConnectWallet = (error?: any, payload?: any, peraWallet?: any) => {
  //   connectWallet();
  // };
  const [status, setStatus] = useState<StatusAPI>(StatusAPI.IDLE);
  const [walletAddress, setWalletAddress] = useState('');
  const [walletType, setWalletType] = useState('');

  // Track DailyActiveUsers
  useEffect(() => {
    // @ts-expect-error
    if (mixpanel?.__loaded) {
      const today = new Date().toISOString().split('T')[0];
      const lastVisit = localStorage.getItem('lastVisit');
      const lastVisitWallet = localStorage.getItem('lastVisitWallet');
      const firstTwoHexChars = walletAddress?.slice(0, 2);
      const chain = firstTwoHexChars === '0x' ? 'BINANCE' : 'ALGORAND';
      if (!lastVisit || lastVisit !== today) {
        mixpanel.track(DAILY_ACTIVE_USERS, {
          walletAddress,
          chain,
          walletType,
        });
        localStorage.setItem('lastVisit', today);
      }
      if (lastVisitWallet || lastVisitWallet !== today) {
        mixpanel.track(DAILY_ACTIVE_WALLETS, {
          walletAddress,
          chain,
          walletType,
        });
        localStorage.setItem('lastVisitWallet', today);
      }
    }
  }, [mixpanel, walletAddress, walletType]);

  const connectWallet = useCallback(
    async (
      type = WalletOption.AlgoMobile,
      address = '',
      peraWallet = {},
      walletProvider = null,
      magicChain = null,
    ) => {
      if (!account) {
        try {
          walletManager.setType(type);
          localStorage.setItem('walletManagerType', type);
          if (localStorage.getItem('token')) {
            dispatch({ type: actiontype.SET_TOKEN });
          }
          if ([WalletOption.AlgoMobile, WalletOption.DEFLY].includes(type)) {
            await walletManager.connect(peraWallet);
          }
          setStatus(StatusAPI.LOADING);
          if (
            [
              WalletOption.BSC,
              WalletOption.TRUST,
              WalletOption.METAMASK,
            ].includes(type) ||
            (type === WalletOption.MAGIC && magicChain === 'BINANCE')
          ) {
            const {
              bnbBalance = 0,
              USDCBalance = 0,
              FLOKIBalance = 0,
              DOGEBalance = 0,
              BTCBBalance = 0,
              ETHBalance = 0,
              BUSDBalance = 0,
              USDTBalance = 0,
              isOptedIn = false,
            } = (await fetchBNBBalance(address, walletProvider)) || {};
            const providerKey =
              type === WalletOption.BSC
                ? 'bscProvider'
                : type === WalletOption.TRUST
                ? 'trustProvider'
                : 'metamaskProvider';
            dispatch({
              type: actiontype.ADDWALLET,
              payload: {
                account: address,
                balanceZone: 0,
                balanceAlgo: 0,
                gAlgoBalance: 0,
                pepeBalance: 0,
                minAlgoBalance: 0,
                option:
                  type === WalletOption.BSC
                    ? WalletOption.BSC
                    : magicChain
                    ? WalletOption.MAGIC
                    : type === WalletOption.TRUST
                    ? WalletOption.TRUST
                    : WalletOption.METAMASK,
                afkelephants,
                balanceBNB: bnbBalance,
                FLOKIBalance,
                USDCBalance,
                DOGEBalance,
                BTCBBalance,
                ETHBalance,
                BUSDBalance,
                USDTBalance,
                [providerKey]: walletProvider,
                blockChain: BlockChainEnum.BINANCE,
              },
            });
            localStorage.setItem('blockChain', BlockChainEnum.BINANCE);
            dispatch({
              type: actiontype.SET_OPTIN,
              payload: {
                isOptedIn,
              },
            });
          } else {
            dispatch({
              type: actiontype.ADDWALLET,
              payload: {
                account: address,
                balanceZone: 0,
                balanceAlgo: 0,
                gAlgoBalance: 0,
                option: type,
                afkelephants: [],
                balanceBNB: 0,
                algoStkBalance: 0,
                deflyBalance: 0,
                pepeBalance: 0,
                USDCBalance: 0,
                minAlgoBalance: 0,
              },
            });
            localStorage.setItem('blockChain', BlockChainEnum.ALGORAND);
          }
          setStatus(StatusAPI.FULFILLED);
        } catch (error: any) {
          toast.error(ErrorHelper('Cannot connect to wallet services'));
          setStatus(StatusAPI.REJECTED);
        } finally {
          if (address) {
            localStorage.setItem('walletAddress', address);
            setWalletAddress(address);
            setWalletType(type);
          }
        }
      }
    },
    [],
  );
  return { status, connectWallet };
};
